export type AnyFunction = (...args: any[]) => any

export type DebouncedFunction<F extends AnyFunction> = (...args: Parameters<F>) => void

export function createDebouncedFunction<F extends AnyFunction>(
  func: F,
  wait = 100,
): DebouncedFunction<F> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  let previousParams: Parameters<F> | undefined

  function debouncedFunction(...args: Parameters<F>): void {
    previousParams = args

    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func(...args)
      previousParams = undefined
    }, wait)
  }

  return (...args: Parameters<F>) => {
    const parametersHasChanged =
      !previousParams || args.some((arg, i) => !previousParams || arg !== previousParams[i])

    if (parametersHasChanged) {
      if (previousParams != null) {
        func(...previousParams)
      }

      debouncedFunction(...args)
    }
  }
}
